import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Box, Typography, IconButton ,
   MenuItem,
    Select,
    FormControl,
    InputLabel,
    Grid
} from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useAuth } from "../../../../AuthProvider";
import { useLocation } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const ClassTimeTable = () => {
  const tableRef = useRef();
  const navigate = useNavigate();
  const {userId, oId , pId,role} = useAuth();
  const location = useLocation();
  const { student } = location.state || {};

  const [timetableData, setTimetableData] = useState([]);
  const [classTeacherData, setClassTeacherData] = useState({});
  // const filteredData = location.state?.filteredData || [];

  const { selectedClass, selectedSection ,selectedCourseType,ClassTeacherId } = location.state || {};
  // const [timeTableData, setTimeTableData] = useState([]);
    const [timeSlots, setTimeSlots] = useState([]);
  

       const [users, setUsers] = useState([]);
      const [selectedUsers, setSelectedUsers] = useState('');
      const isPrincipal = role?.startsWith("PRINCIPAL") || false;
      const UserId = userId || selectedUsers;
    
      useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch users');
                }
                const data = await response.json();
                setUsers(data);
                if (data.length > 0) {
                  setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
              }
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, []);

  //timeslots api 
    const fetchTimeSlots = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/dynamic-time-table/getAllTimeSlots/${oId}/${pId}`);
        const data = await response.json();
    
        if (response.ok && Array.isArray(data)) {
          const normalizedSlots = data.map((slot) => {
            const rawType = slot.type.toLowerCase();
            let normalizedType = "period";
            let label = null;
    
            if (rawType.includes("break")) {
              normalizedType = rawType.includes("lunch") ? "lunch" : "break";
              label = slot.type; // e.g., "Lunch Break", "Interval Break"
            }
    
            return {
              time: slot.timeSlot,
              type: normalizedType,
              label: label,
            };
          });
    
          setTimeSlots(normalizedSlots);
        } else {
          setTimeSlots([]);
        }
      } catch (error) {
        console.error("Error fetching time slots:", error);
        setTimeSlots([]);
      }
    };
    useEffect(() => {
      fetchTimeSlots();
    }, []);

   //Classteacher DATA
   useEffect(() => {
    const fetchClassTeacerData = async () => {
      if(!UserId) return;
      try {
        const response = await fetch(
          `${baseUrl}/api/classTeacher/getClassTeacherNameAndTeacherId/${selectedClass}/${selectedSection}/${oId}/${pId}/${UserId}`
        );          
        const data = await response.json();
        setClassTeacherData(data);
      } catch (error) {
        console.error("Error fetching Class Teacher data:", error);
      }
    };

    if (selectedClass && selectedSection) {
      fetchClassTeacerData(); // Fetch only if class and section are available
    }
  }, [selectedClass, selectedSection,UserId]);


  //timetable data
  useEffect(() => {
    const fetchTimeTableData = async () => {
      if(!UserId) return;
      try {
        const response = await fetch(
          `${baseUrl}/api/classSchedule/getAllClassSchedules/${oId}/${pId}/${UserId}?romanNumberClass=${selectedClass}&sections=${selectedSection}`
        );
        if (!response.ok) {
          throw new Error(`Server Error: ${response.status}`); // will go to catch
        }
        const data = await response.json();
        setTimetableData(data);
      } catch (error) {
        console.error("Error fetching timetable data:", error);
        setTimetableData([])
      }
    };

    if (selectedClass && selectedSection) {
      fetchTimeTableData(); // Fetch only if class and section are available
    }
  }, [selectedClass, selectedSection,UserId]);




  const handlePrint = () => {
    window.print(); // Directly trigger print on the current page
  };

  

const normalizeTimeSlot = (timeSlot) => {
  return timeSlot
    .replace(/\s*-\s*/g, " - ") // Ensure consistent dash spacing
    .replace(/\s*AM|\s*PM/gi, "") // Remove AM/PM for comparison
    .trim();
};


  const renderTableCell = (day, timeSlot) => {
    const normalizedTimeSlot = normalizeTimeSlot(timeSlot); // Normalize the time slot for comparison

    const periodData = timetableData.find(
      (item) =>
        item.dayName === day &&
        normalizeTimeSlot(item.timeSlot) === normalizedTimeSlot
    );


    if (periodData) {
      return (
        <>
          {/* <span style={{ fontSize: "10px" }}>{periodData.section}</span> <br /> */}
          <span style={{ fontSize: "11px" }}>{periodData.subject}</span>
          <br />
          <strong style={{ fontSize: "10px" }}>
            {periodData.teacherFirstName} {periodData.teacherLastName}
          </strong>{" "}
        </>
      );
    }

    // Return "NA" if no data is available for the given day and time slot
    return "---";
  };

  return (
    <div
      style={{
        marginTop: "5%",
        padding: "15px",
        boxShadow: "5px 5px 15px rgba(0,0,0,0.2)",
        backgroundColor: "white",
        // height: "820px",
        marginRight: "15px",
        marginLeft: "15px",
        // marginBottom: "10px",
      }}
    >
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        {/* Back Icon and Main Heading Side by Side */}
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#2e2a54",
              display: "flex",
              alignItems: "center",
            }}
          >
            Class Time Table

            <h4
              style={{
                color: "#3b8a6d",
                marginLeft: "5px",
                textDecoration: "underline",
              }}
            >
              {/* {student.teacherFirstName} {student.teacherLastName} # */}
              {/* {student.teacherId} */}
            </h4>
          </Typography>
        </Box>

        {/* Flexible space to push buttons to the right */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Action Buttons with Effects */}
        <Box display="flex" gap={2}>

           {/* {isPrincipal && (
              <Grid item xs={6} sx={{ display: "flex", justifyContent: "flex-end",pt:2 }}>
                <FormControl style={{ width: "200px" }} size="small">
                  <InputLabel>Select Schedule Admin</InputLabel>
                  <Select
                    value={selectedUsers}
                    onChange={(e) => setSelectedUsers(e.target.value)}
                    label="Select Schedule Admin"
                  >
                    {users.map((user) => (
                      <MenuItem key={user.userId} value={user.userId}>
                        {user.userId} - {user.firstName} {user.lastName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )} */}
          

          <Button
            variant="contained"
            onClick={handlePrint}
            sx={{
              backgroundColor: "#6E69B0",
              color: "#fff",
              "&:hover": { backgroundColor: "#58548E" },
              transition: "background-color 0.3s ease",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              marginRight: "29px",
              marginTop: "20px",
            }}
          >
            Print
          </Button>

        </Box>
      </Box>

      <Card
        id="print-section"
        style={{
          padding: "10px 20px 20px 20px",
          boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.2)",
          width: "97%", // Fixed typo from "Width" to "width",
          margin: "auto",
        }}
      >
        {/* Time Table Title */}
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            paddingBottom: "10px",
            marginBottom: "5px",
          }}
        >
          {selectedClass} {selectedCourseType}-{selectedSection} Time Table
        </Typography>
        {/* Teacher's Name and ID Section */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ marginBottom: "10px" }}
        >
          {/* Name and ID aligned to the left */}
          <div>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#6c63ff" }}
            >
              Class Teacher Name:{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {classTeacherData.teacherFirstName} {classTeacherData.teacherLastName}
              </span>
            </Typography>

            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#6c63ff" }}
            >
              Teacher ID:{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {classTeacherData.teacherId}
              </span>
            </Typography>
          </div>
        </Box>

        {/* Time Table */}
        <table
          ref={tableRef}
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
            tableLayout: "fixed",
            wordWrap: "break-word",
          }}
        >
          <thead>
            <tr>
              <th style={headerStyle}>DAY / HOUR</th>
              {timeSlots.map((slot, index) => (
                <th key={index} style={headerStyle}>
                  {slot.time}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(
              (day, dayIndex) => (
                <tr key={day}>
                  <td
                    style={{
                      ...cellStyle,
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      fontSize: "11px",
                    }}
                  >
                    {day}
                  </td>

                  {timeSlots.map((slot, index) => {
          if (slot.type === "period") {
            return (
              <td key={`period-${index}`} style={cellStyle}>
                {renderTableCell(day, slot.time)}
              </td>
            );
          }

          if (dayIndex === 0) {
            return (
              <td
                key={`break-${index}`}
                rowSpan={6}
                style={{
                  ...cellStyle,
                  writingMode: "vertical-rl",
                  textAlign: "center",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  width: "5%",
                  backgroundColor: slot.type === "lunch" ? "#e0e0e0" : "#e0e0e0",
                }}
              >
                {slot.label || slot.type.toUpperCase()}
              </td>
            );
          }

          return null;
        })}

                </tr>
              )
            )}
          </tbody>
        </table>
      </Card>

      {/* Print-only CSS */}
      <style>
  {`
    @media print {
      body * {
        visibility: hidden;
      }
      #print-section, #print-section * {
        visibility: visible;
      }
      #print-section {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 0 !important;
        margin: 0 !important;
        box-shadow: none !important;
      }
      #print-section table {
        width: 100% !important;
        border-collapse: collapse !important;
        table-layout: fixed !important; /* Ensures equal column width */
      }
      #print-section th,
      #print-section td {
        border: 1px solid #000 !important;
        padding: 4px !important;
        font-size: 12px !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
        white-space: normal !important;
        max-width: 150px !important;
      }
      /* Optional: truncate instead of wrap */
      /* 
      #print-section td {
        text-overflow: ellipsis !important;
        overflow: hidden !important;
        white-space: nowrap !important;
      }
      */
      th:nth-child(1), td:nth-child(1) {
        width: 120px !important; /* e.g. for day names */
      }
    }
  `}
</style>

    </div>
  );
};

const headerStyle = {
  border: "1px solid black",
  padding: "10px",
  backgroundColor: "#f2f2f2",
};

const cellStyle = {
  border: "1px solid black",
  padding: "10px",
  height: "50px",
  fontWeight: "bold",
};

export default ClassTimeTable;